var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"button",class:[
    ("button--" + _vm.type),
    ("button--size-" + _vm.size),
    !_vm.padded && 'button--not-padded' ]},_vm.$listeners),[(_vm.$slots['before'])?_c('span',{staticClass:"button__before"},[_vm._t("before")],2):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.$slots['after'])?_c('span',{staticClass:"button__after"},[_vm._t("after")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }